module.exports = __webpack_public_path__ + "media/images/front/bg_top_events-8c6c1090d0d6b7a24619482483a04d6a.jpg";